import { cn } from '@tripleten/cn';

export const cnKcApp = cn('kc-app');
